export default function mainAddr() {
  return "https://gql.gm.star-horizon.com";
}
